import { render, staticRenderFns } from "./Puclic-Card.vue?vue&type=template&id=6a4804f2&scoped=true&"
import script from "./Puclic-Card.vue?vue&type=script&lang=js&"
export * from "./Puclic-Card.vue?vue&type=script&lang=js&"
import style0 from "./Puclic-Card.vue?vue&type=style&index=0&id=6a4804f2&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4804f2",
  null
  
)

export default component.exports